import React, { Component } from 'react';
import { confirmAlert } from 'react-confirm-alert';
import { toast } from 'react-toastify';
import TradeResponsesTable from './tradeResponsesTable';
import {
  getTradeResponses,
  deleteTradeResponse,
} from '../services/tradeResponseService';
import auth from '../services/authService';
import Spinner from './common/spinner';
import NotFound from './notFound';
import Alert from './common/alert';
//import AddButton from './common/addButton';

class TradeResponses extends Component {
  state = {
    tresponses: [],
    loading: false,
  };

  async componentDidMount() {
    this.setState({ loading: true });
    const tresponses_response = await getTradeResponses();
    this.setState({ loading: false });
    const { data: tresponses } = tresponses_response;
    this.setState({ tresponses });
  }

  handleDelete = async (tresponse) => {
    const originalTradeResponses = this.state.tresponses;
    const tresponses = originalTradeResponses.filter(
      (t) => t._id !== tresponse._id
    );
    this.setState({ tresponses });

    try {
      confirmAlert({
        customUI: ({ onClose }) => {
          return (
            <Alert
              name="Trade Response"
              onClose={() => {
                this.setState({ tresponses: originalTradeResponses });
                onClose();
              }}
              onDelete={async () => {
                await deleteTradeResponse(tresponse._id);
                onClose();
              }}
            />
          );
        },
      });
    } catch (ex) {
      if (ex.response && ex.response.status === 404)
        toast('This Trade Response has already been deleted.');

      this.setState({ tresponses: originalTradeResponses });
    }
  };

  getPagedData = () => {
    const { tresponses } = this.state;

    return { data: tresponses };
  };

  render() {
    const { loading } = this.state;
    const { data: tresponses } = this.getPagedData();
    const { isAdmin } = auth.getCurrentUser();
    if (loading) return <Spinner message="loading page data..." />;
    return isAdmin ? (
      <React.Fragment>
        {/* <AddButton link="/trade-responses/new" value="Add Trade Response" /> */}
        <TradeResponsesTable
          tresponses={tresponses}
          onDelete={this.handleDelete}
          message="Trade Responses"
        />
      </React.Fragment>
    ) : (
      <NotFound />
    );
  }
}

export default TradeResponses;
